import { useState, useCallback } from 'react';
import Cropper from 'react-easy-crop';
import { Button } from '@/components/ui/button';
import { DialogFooter } from '@/components/ui/dialog';
import { getCroppedImg } from '@/lib/image';

interface ImageCropperCoverProps {
  image: string;
  onCrop: (blob: Blob) => void;
  onCancel: () => void;
  aspectRatio: number;
}

export function ImageCropperCover({ image, onCrop, onCancel, aspectRatio }: ImageCropperCoverProps) {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const onCropComplete = useCallback((croppedArea: any, croppedAreaPixels: any) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleCrop = async () => {
    try {
      setIsLoading(true);
      if (!croppedAreaPixels) return;
      
      const croppedImage = await getCroppedImg(
        image,
        croppedAreaPixels
      );
      
      onCrop(croppedImage);
    } catch (error) {
      console.error('Error cropping image:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="relative flex flex-col h-[500px]">
      <div className="relative flex-1 bg-muted">
        <Cropper
          image={image}
          crop={crop}
          zoom={zoom}
          aspect={aspectRatio}
          onCropChange={setCrop}
          onCropComplete={onCropComplete}
          onZoomChange={setZoom}
          classes={{
            containerClassName: 'relative h-full',
            mediaClassName: 'max-h-full',
          }}
        />
      </div>

      <DialogFooter className="flex justify-end gap-2 py-4">
        <Button
          type="button"
          variant="outline"
          onClick={onCancel}
          disabled={isLoading}
        >
          Cancelar
        </Button>
        <Button
          type="button"
          onClick={handleCrop}
          disabled={isLoading}
        >
          Cortar Imagem
        </Button>
      </DialogFooter>
    </div>
  );
}